module.exports = __webpack_public_path__ + "static/img/step4.8df17d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/step4.png
// module id = iJS6
// module chunks = 1